import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { usePagination } from "@/utils/stores/pagination";
import { useFiltering } from "@/utils/stores/filtering";
import { useBase } from "@/utils/stores/base";

const storeName = "country";

export const useCountryStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);

  const { sortedResources } = useFiltering(all, searchQuery, "attributes.name");
  const { paginatedResources, goToPage, goToNextPage, goToPreviousPage, paginationRange, totalPages, currentPage } = usePagination(sortedResources, 10);
  const { baseFetchOne, baseFetchAll, watchRemoteResourceChange } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("countries", errorCallback);
  };

  const fetchOne = async (id, errorCallback) => {
    return await baseFetchOne("countries", id, errorCallback);
  };

  onMounted(async () => {
    await fetchAll();
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    fetchCountries: fetchAll,
    fetchCountry: fetchOne,
    searchQuery,
    paginatedCountries: paginatedResources,
    sortedCountries: sortedResources,
    goToPage,
    goToNextPage,
    goToPreviousPage,
    paginationRange,
    totalPages,
    currentPage
  };
});
